export default __webpack_public_path__ + "static/media/ReleaseandBuildGuides_release_process.9c347061.png";